import ContactTab from './contactTab';

export default ContactTab;
